import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 创建应用实例
const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局错误处理
const ignoreResizeObserverErrors = () => {
  const errorHandler = (event) => {
    // 忽略ResizeObserver错误
    if (event.message && event.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation()
    }
  }

  // 处理常规错误
  window.addEventListener('error', errorHandler, true)

  // 处理Promise错误
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation()
      event.preventDefault()
    }
  }, true)
}

// 初始化错误处理
ignoreResizeObserverErrors()

// 使用插件
app.use(router)
app.use(store)
app.use(ElementPlus, { size: 'default' })

// 添加全局错误处理
app.config.errorHandler = (err) => {
  // 忽略ResizeObserver错误
  if (err && err.message && err.message.includes('ResizeObserver')) {
    return
  }
  console.error('Global error:', err)
}

// 挂载应用
app.mount('#app')
